import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureEvent } from '@/lib/analytics';

function routeToSection(pathname: string): string {
  const firstSegment = pathname.split('/').filter(Boolean)[0];
  return firstSegment || 'onboarding';
}

function routeToSafePath(pathname: string): string {
  if (pathname.startsWith('/review/')) return '/review/:emailId';
  if (pathname.startsWith('/inbox/')) return '/inbox/:emailId';
  return pathname;
}

function routeToSettingsSection(pathname: string): string {
  if (pathname === '/settings') return 'main';
  return pathname.replace('/settings/', '').split('/')[0] || 'main';
}

export function AnalyticsRouteTracker() {
  const location = useLocation();
  const safePath = routeToSafePath(location.pathname);

  useEffect(() => {
    captureEvent('$pageview', {
      path: safePath,
      route: safePath,
      section: routeToSection(safePath),
    });
    if (safePath.startsWith('/settings')) {
      captureEvent('settings_section_viewed', {
        section: routeToSettingsSection(safePath),
      });
    }
  }, [safePath]);

  return null;
}
